var map = {
	"./ca-ES/strings.json": [
		4028,
		4028
	],
	"./en-AU/strings.json": [
		4463,
		4463
	],
	"./en-CA/strings.json": [
		9777,
		9777
	],
	"./en-GB/strings.json": [
		9992,
		9992
	],
	"./en-IE/strings.json": [
		3399,
		3399
	],
	"./en/strings.json": [
		352,
		352
	],
	"./es-ES/strings.json": [
		272,
		272
	],
	"./es-US/strings.json": [
		1488,
		1488
	],
	"./fr-CA/strings.json": [
		2064,
		2064
	],
	"./fr-FR/strings.json": [
		8832,
		8832
	],
	"./ja-JP/strings.json": [
		1605,
		1605
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2946;
module.exports = webpackAsyncContext;